<button class="map-sidebar-item" (click)="onMapItemClicked()">
    <div class="map-sidebar-item__icon">
        <ui-map-item-icon
            [iconPath]="mapItem.iconPath"
            [altText]="mapItem.iconLabel"
            [attr.hidden]="!mapItem.iconLabel"
        />
    </div>
    <div class="map-sidebar-item__text">
        @if (mapItem) {
            <h3 class="map-sidebar-item__title">{{ mapItem.title }}</h3>

            <h4 class="map-sidebar-item__sub-title">{{ mapItem.shortAddress }}</h4>
        }

        <div
            uiPopupContentHost
            class="custom-content"
        ></div>
    </div>
</button>
